

export default {
  enums: [
    { id: 'IN' },
    { id: 'OUT' },
  ]
};